const hrmUrls = {
    fetchStates: {
        url: '/hrm/states/',
    },
    fetchDivisions: {
        url: '/hrm/:id/divisions/'
    },
    fetchDepartments: {
        url: '/hrm/:id/departments'
    },
    fetchPositions: {
        url: '/hrm/:id/positions'
    },
    fetchStateParents:{
        url:'/hrm/:id/stateParents/'
    },
    fetchDepartment:{
        url:'/hrm/:id/department'
    }
};

export default hrmUrls;